namespace e5 {
    export class TouchEmulator {
        private static _created: boolean = false;

        private _cursors: Cursor[] = [];
        private _current: Cursor = null;

        private constructor() {
            if (TouchEmulator._created) {
                console.warn("You cannot create mulitiple instances of TouchEmulator.");
                return;
            }
            TouchEmulator._created = true;

            document.addEventListener("mousedown", (e) => {
                e.stopImmediatePropagation();
                e.preventDefault();
                this._current = new Cursor(e);
                this._cursors.push(this._current);
                if (e.ctrlKey)
                    this._current = null;
            },
                {
                    capture: true,
                    passive: false
                });

            document.addEventListener("mousemove", (e) => {
                e.stopImmediatePropagation();
                if (!this._current)
                    return;
                this._current.move(e);
            },
                {
                    capture: true,
                    passive: false
                });

            document.addEventListener("mouseup", (e) => {
                e.stopImmediatePropagation();
                if (!this._current)
                    return;
                if (!e.ctrlKey) {
                    this._current.up(e);
                    this._cursors.splice(this._cursors.indexOf(this._current), 1);
                }
                this._current = null;
            },
                {
                    capture: true,
                    passive: false
                });

            document.addEventListener("keyup", (e) => {
                //If shift key is released.
                if (e.keyCode === 16)
                    this.clear();
            });

            window.addEventListener("blur", (e) => {
                this.clear();
            });
        }

        private clear(): void {
            for (var cursor of this._cursors) {
                cursor.up();
            }
        }

        public static create(): void {
            if (!this.isSupported) {
                console.warn("TouchEmulator is not supported.");
                return;
            }
            if (this._created)
                return;
            new TouchEmulator();
        }

        public static get isSupported(): boolean {
            return Boolean((<any>window)["TouchEvent"]);
        }
    }

    class Cursor {
        private static _uid: number = 1024;

        private _uid: number;
        private _element: HTMLDivElement;
        private _event: MouseEvent;
        private _touch: Touch;

        constructor(e: MouseEvent) {
            this._uid = Cursor._uid++;

            var div = document.createElement("div");
            div.style.position = "absolute";
            div.style.top = "0";
            div.style.left = "0";
            div.style.pointerEvents = "none";
            div.style.width = "10px";
            div.style.height = "10px";
            div.style.marginLeft = "-5px";
            div.style.marginTop = "-5px";
            div.style.zIndex = "100000";
            div.style.backgroundColor = "rgba(255, 0, 255, 0.5)";
            div.style.borderRadius = "50%";
            document.body.appendChild(div);

            this._element = div;

            this.down(e);
        }

        private down(e: MouseEvent): void {
            // console.log("down");
            this._event = e;
            this.updateTouch(e);
            this._element.style.transform = "translate(" + e.pageX + "px, " + e.pageY + "px)";
            e.target.dispatchEvent(new TouchEvent("touchstart", {
                altKey: e.altKey,
                shiftKey: e.shiftKey,
                bubbles: true,
                changedTouches: [this._touch],
            }));
        }

        public move(e: MouseEvent): void {
            // console.log("move");
            this._event = e;
            this.updateTouch(e);
            this._element.style.transform = "translate(" + e.pageX + "px, " + e.pageY + "px)";
            e.target.dispatchEvent(new TouchEvent("touchmove", {
                altKey: e.altKey,
                shiftKey: e.shiftKey,
                bubbles: true,
                changedTouches: [this._touch],
            }));
        }

        public up(e: MouseEvent = null): void {
            // console.log("up");
            e = e || this._event
            this.updateTouch(e);
            e.target.dispatchEvent(new TouchEvent("touchend", {
                altKey: e.altKey,
                shiftKey: e.shiftKey,
                bubbles: true,
                changedTouches: [this._touch],
            }));
            this._element.remove();
            this._touch = null;
        }

        private updateTouch(e: MouseEvent): void {
            this._touch = new Touch({
                pageX: e.pageX,
                pageY: e.pageY,
                clientX: e.clientX,
                clientY: e.clientY,
                target: e.target,
                identifier: this._uid
            });
        }
    }
}